<template>
  <div class="flex h-full min-w-0 overflow-y-hidden">
    <div class="min-w-64 overflow-visible">
      <h2 class="font-bold pl-5 pt-8">Settings</h2>
      <settings-list />
    </div>

    <shadowed-wrapper class="w-full min-w-0 overflow-hidden">
      <router-view></router-view>
    </shadowed-wrapper>
  </div>
</template>

<script>
import ShadowedWrapper from '@/components/base-components/ShadowedWrapper.vue'
import SettingsList, { getSettingsSectionTitle } from '@/components/settings/SettingsList.vue'

export default {
  name: 'Settings',

  metaInfo() {
    return { title: `${this.settingsSectionTitle} | Settings` }
  },

  components: { SettingsList, ShadowedWrapper },

  computed: {
    settingsSectionTitle() {
      return getSettingsSectionTitle(this.$route.name)
    }
  }
}
</script>

